
import React, { useState } from 'react';
import { ICONS } from '../constants';
import clsx from 'clsx';

interface ComparisonViewProps {
  before: string | null;
  after: string;
}

const ComparisonView: React.FC<ComparisonViewProps> = ({ before, after }) => {
  const [showOriginal, setShowOriginal] = useState(false);

  // If no original image is provided, just show the result
  if (!before) {
      return (
          <div className="relative w-full h-full select-none overflow-hidden bg-transparent">
              <img src={after} alt="Result" className="w-full h-full object-contain" />
          </div>
      );
  }

  const handleStart = (e: React.SyntheticEvent) => {
    // Prevent default to stop scrolling/selecting on mobile while holding
    // e.preventDefault(); // Commented out to allow clicking if needed, but touch-action: none handles scroll prevention usually
    setShowOriginal(true);
  };

  const handleEnd = (e: React.SyntheticEvent) => {
    setShowOriginal(false);
  };

  return (
    <div className="relative w-full h-full select-none overflow-hidden bg-transparent group">
      
      {/* Main Image Display */}
      <img 
        src={showOriginal ? before : after} 
        alt={showOriginal ? "Original Source" : "Reshot Result"} 
        className="w-full h-full object-contain transition-opacity duration-100" 
      />
      
      {/* Status Label (Top Left) */}
      <div className="absolute top-4 left-4 z-10 pointer-events-none">
          <span className={clsx(
              "px-3 py-1.5 rounded text-[10px] font-bold uppercase tracking-widest backdrop-blur-md border border-white/10 shadow-lg transition-colors",
              showOriginal ? "bg-white text-black border-white" : "bg-black/60 text-white"
          )}>
              {showOriginal ? 'Original' : 'Result'}
          </span>
      </div>

      {/* Hold to View Button (Bottom Center) - Moved up to avoid overlap */}
      <div className="absolute bottom-20 left-1/2 -translate-x-1/2 z-20">
        <button
            className="flex items-center gap-2 px-5 py-2.5 rounded-full bg-black/60 hover:bg-black/80 backdrop-blur-xl border border-white/20 text-white shadow-xl transition-all active:scale-95 cursor-pointer touch-none select-none group/btn focus:outline-none focus:ring-2 focus:ring-white"
            onMouseDown={handleStart}
            onMouseUp={handleEnd}
            onMouseLeave={handleEnd}
            onTouchStart={handleStart}
            onTouchEnd={handleEnd}
            onContextMenu={(e) => e.preventDefault()}
            title="Hold to see original"
            aria-label="Hold to view original image"
        >
            <ICONS.Eye className={clsx("w-4 h-4 transition-transform", showOriginal ? "scale-110" : "group-hover/btn:scale-110")} />
            <span className="text-[10px] font-bold uppercase tracking-[0.15em]">Hold to Compare</span>
        </button>
      </div>
      
    </div>
  );
};

export default ComparisonView;
